import {useEffect} from 'react';

import Backdrop from 'components/Backdrop/Backdrop';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {createPortal} from 'react-dom';
import './Modal.scss';
import {setModalAC} from 'store/modal/modalSlice';

import {ModalObject} from './ModalObject';

const Modal = () => {
  const dispatch = useSetGlobalState();
  const modal = useGlobalState((state) => state.modal.modal);

  const modalRoot = document.getElementById('modal-portal') as HTMLElement;

  const handleClose = () => {
    dispatch(setModalAC(null));
  };

  useEffect(() => {
    if (modal) window.scrollTo(0, 0);
  }, [modal]);

  return createPortal(
    <div className="modal">
      {modal && (
        <>
          <Backdrop onClick={handleClose} />
          <div className="modal__content">{ModalObject[modal] || null}</div>
        </>
      )}
    </div>,
    modalRoot,
  );
};

export default Modal;
